<template>
    <div id="app" v-if="dropdownCheck()">
        <Header></Header>
        <router-view />
        <Footer></Footer>
    </div>
</template>
<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { mapActions } from "vuex";
export default {
    name: "App",
    components: {
        Header,
        Footer,
    },
    created() {
        this.getDropdownRadio();
        this.getCountries();
    },
    methods: {
        ...mapActions(["getDropdownRadio", "getCountries"]),
        dropdownCheck() {
            let valid = false;
            if (
                JSON.parse(this.$store.state.membershipTypes) !== null &&
                JSON.parse(this.$store.state.countries) !== null
            ) {
                valid = true;
            }
            return valid;
        },
    },
};
</script>
<style>
#app {
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;
}

nav a {
    font-weight: bold;
    color: #2c3e50;
}

nav a.router-link-exact-active {
    color: #42b983;
}
.v-toast__text{
    color: white;
}
@media screen and (max-width: 768px) {
    .v-toast {
      margin-right: 20PX !important;
    }
  }
</style>
